import { render, staticRenderFns } from "./ProjectMemberCardList.vue?vue&type=template&id=2eb818f1&scoped=true&"
import script from "./ProjectMemberCardList.vue?vue&type=script&lang=ts&"
export * from "./ProjectMemberCardList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectMemberCardList.vue?vue&type=style&index=0&id=2eb818f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb818f1",
  null
  
)

export default component.exports